export default __webpack_public_path__ + "static/media/ModalImage34.63a3ebf8.PNG";